import React, { useEffect, useRef, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import { 
  Grid, 
  LinearProgress, 
  Typography, 
  Button, 
  Divider, 
  Card, 
  CardHeader, 
  CardContent, 
  Box, 
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  IconButton,
  Chip,
  Avatar,
  Tooltip
} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import SendIcon from "@material-ui/icons/Send";
import PhoneIcon from "@material-ui/icons/Phone";
import MessageIcon from "@material-ui/icons/Message";
import ScheduleIcon from "@material-ui/icons/Schedule";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import DoneIcon from "@material-ui/icons/Done";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import ListAltIcon from "@material-ui/icons/ListAlt";
import PieChartIcon from '@material-ui/icons/PieChart';
import BarChartIcon from '@material-ui/icons/BarChart';
import GetAppIcon from "@material-ui/icons/GetApp";
import { useDate } from "../../hooks/useDate";
import usePlans from "../../hooks/usePlans";
import { AuthContext } from "../../context/Auth/AuthContext";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { has, get, isNull } from "lodash";
import api from "../../services/api";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title as ChartTitle,
  Tooltip as ChartTooltip,
  Legend,
  Filler,
} from 'chart.js';
import { Line, Pie, Doughnut } from 'react-chartjs-2';

// import { SocketContext } from "../../context/Socket/SocketContext";
import { i18n } from "../../translate/i18n";

// Registrar componentes do Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  ChartTitle,
  ChartTooltip,
  Legend,
  Filler
);

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(2),
    overflowY: "scroll",
    ...theme.scrollbarStyles,
    marginBottom: theme.spacing(2),
  },
  textRight: {
    textAlign: "right",
  },
  tabPanelsContainer: {
    padding: theme.spacing(2),
  },
  summaryCards: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  summaryCard: {
    padding: theme.spacing(2),
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardHeader: {
    paddingBottom: 0,
  },
  cardIcon: {
    color: theme.palette.primary.main,
    fontSize: 40,
    marginBottom: theme.spacing(1),
  },
  progressContainer: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  tableContainer: {
    marginTop: theme.spacing(3),
  },
  tableTitle: {
    margin: theme.spacing(2, 0),
    fontWeight: 500,
  },
  chartContainer: {
    height: 300,
    marginBottom: theme.spacing(4),
  },
  chip: {
    margin: theme.spacing(0.5),
  },
  statusChip: {
    color: '#fff',
    fontWeight: 'bold',
  },
  deliveredChip: {
    backgroundColor: theme.palette.success.main,
  },
  pendingChip: {
    backgroundColor: theme.palette.warning.main,
  },
  failedChip: {
    backgroundColor: theme.palette.error.main,
  },
  pieChartContainer: {
    height: 250,
    position: 'relative',
    marginTop: theme.spacing(2),
  },
  sectionTitle: {
    fontWeight: 500,
    margin: theme.spacing(2, 0),
  },
  detailsCard: {
    marginBottom: theme.spacing(2),
  },
  fullWidthGrid: {
    width: '100%',
  },
  avatar: {
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
  },
}));

const CampaignReport = () => {
  const classes = useStyles();
  const history = useHistory();

  const { campaignId } = useParams();
  // Detecta se é relatório de MetaTemplate pela URL
  const isTemplate = history.location.pathname.startsWith("/meta-template/");

  const [campaign, setCampaign] = useState({});
  const [validContacts, setValidContacts] = useState(0);
  const [delivered, setDelivered] = useState(0);
  const [confirmationRequested, setConfirmationRequested] = useState(0);
  const [confirmed, setConfirmed] = useState(0);
  const [percent, setPercent] = useState(0);
  const [loading, setLoading] = useState(false);
  const [messageRows, setMessageRows] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [shippingPage, setShippingPage] = useState(1);
  const [totalShippingPages, setTotalShippingPages] = useState(1);
  const [uniqueNumbers, setUniqueNumbers] = useState(0);
  const [failedMessages, setFailedMessages] = useState(0);
  const [totalMessagesSent, setTotalMessagesSent] = useState(0);
  const mounted = useRef(true);
  const refreshingRef = useRef(false);
  const { user, socket } = useContext(AuthContext);

  const { datetimeToClient, datetimeToClientWithSeconds } = useDate();
  const { getPlanCompany } = usePlans();
  
  // Dados para o gráfico de pizza
  const [chartData, setChartData] = useState({
    labels: ['Entregues', 'Aguardando', 'Falhas'],
    datasets: [
      {
        data: [0, 0, 0],
        backgroundColor: [
          'rgba(75, 192, 192, 0.7)',
          'rgba(255, 206, 86, 0.7)',
          'rgba(255, 99, 132, 0.7)',
        ],
        borderColor: [
          'rgba(75, 192, 192, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(255, 99, 132, 1)',
        ],
        borderWidth: 1,
      },
    ],
  });
  
  // Opções para o gráfico de pizza
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
      },
    },
  };

  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      const planConfigs = await getPlanCompany(undefined, companyId);
      if (!planConfigs.plan.useCampaigns) {
        toast.error("Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.");
        setTimeout(() => {
          history.push(`/`)
        }, 1000);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (mounted.current) {
      findCampaign();
    }

    return () => {
      mounted.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (mounted.current) {
      if (has(campaign, "contactList") && has(campaign.contactList, "contacts")) {
        const contactList = get(campaign, "contactList");
        const valids = contactList.contacts.filter((c) => c.isWhatsappValid);
        setValidContacts(valids.length);
      } else if (has(campaign, "tagListId")) {
        // Se estamos usando tags em vez de listas de contato
        setValidContacts(delivered); // Usamos as entregas como contatos válidos
      }

      if (has(campaign, "shipping") && Array.isArray(campaign.shipping)) {
        const contacts = get(campaign, "shipping");
        const delivered = contacts.filter((c) => !isNull(c.deliveredAt));
        const confirmationRequested = contacts.filter(
          (c) => !isNull(c.confirmationRequestedAt)
        );
        const confirmed = contacts.filter(
          (c) => !isNull(c.deliveredAt) && !isNull(c.confirmationRequestedAt)
        );
        setDelivered(delivered.length);
        setConfirmationRequested(confirmationRequested.length);
        setConfirmed(confirmed.length);
      }
    }
  }, [campaign]);

  useEffect(() => {
    // Evitar divisão por zero
    if (validContacts > 0) {
      setPercent((delivered / validContacts) * 100);
    } else {
      setPercent(0);
    }
  }, [delivered, validContacts]);

  // Refresh silencioso de stats + primeira página da tabela (sem piscar loading)
  const refreshStats = async () => {
    if (refreshingRef.current) return;
    refreshingRef.current = true;
    try {
      if (isTemplate) {
        const { data: stats } = await api.get(`/meta-templates/${campaignId}/stats`);
        setCampaign(stats.template || {});
        setDelivered(stats.sentMessages || 0);
        setValidContacts(stats.totalMessages || 0);
        setUniqueNumbers(stats.uniqueRecipients || 0);
        setFailedMessages(stats.failedMessages || 0);
        setTotalMessagesSent(stats.totalMessages || 0);
        setChartData({
          labels: ['Enviados', 'Aguardando', 'Falhas'],
          datasets: [{
            data: [stats.sentMessages, stats.pendingMessages, stats.failedMessages],
            backgroundColor: ['rgba(75,192,192,0.7)', 'rgba(255,206,86,0.7)', 'rgba(255,99,132,0.7)'],
            borderColor: ['rgba(75,192,192,1)', 'rgba(255,206,86,1)', 'rgba(255,99,132,1)'],
            borderWidth: 1,
          }],
        });
        const { data: itemsRes } = await api.get(`/meta-templates/${campaignId}/items`, {
          params: { pageNumber: shippingPage, pageSize: rowsPerPage }
        });
        const formattedRows = (itemsRes.records || []).map(item => {
          const vars = item.variables || {};
          const varSummary = Object.entries(vars).map(([k, v]) => `${k}=${v}`).join(', ');
          return {
            id: item.id, jobId: item.id,
            number: item.contactName || '',
            message: varSummary ? varSummary.substring(0, 50) : '(sem parâmetros)',
            fullMessage: varSummary || '(sem parâmetros)',
            deliveredAt: item.status === 'sent' ? datetimeToClientWithSeconds(item.updatedAt) : null,
            createdAt: item.createdAt ? datetimeToClientWithSeconds(item.createdAt) : null,
            status: item.status === 'sent' ? 'delivered' : item.status === 'error' ? 'failed' : 'pending',
            errorMessage: item.errorMessage || null
          };
        });
        setMessageRows(formattedRows);
        setTotalShippingPages(Math.ceil((itemsRes.count || 0) / rowsPerPage) || 1);
      } else {
        const { data: stats } = await api.get(`/campaigns/${campaignId}/stats`);
        setDelivered(stats.deliveredMessages);
        setValidContacts(stats.totalMessages);
        setUniqueNumbers(stats.uniqueNumbers);
        setFailedMessages(stats.failedMessages);
        setTotalMessagesSent(stats.totalMessages);
        setChartData({
          labels: ['Entregues', 'Aguardando', 'Falhas'],
          datasets: [{
            data: [stats.deliveredMessages, stats.pendingMessages, stats.failedMessages],
            backgroundColor: ['rgba(75,192,192,0.7)', 'rgba(255,206,86,0.7)', 'rgba(255,99,132,0.7)'],
            borderColor: ['rgba(75,192,192,1)', 'rgba(255,206,86,1)', 'rgba(255,99,132,1)'],
            borderWidth: 1,
          }],
        });
        const { data: shippingResponse } = await api.get(
          `/campaigns/${campaignId}/shipping?page=${shippingPage}&pageSize=${rowsPerPage}`
        );
        if (shippingResponse?.shipping) {
          const formattedRows = shippingResponse.shipping.map(item => ({
            id: item.id, jobId: item.jobId, number: item.number,
            message: item.message ? item.message.substring(0, 50) + (item.message.length > 50 ? '...' : '') : '',
            fullMessage: item.message || '',
            deliveredAt: item.deliveredAt ? datetimeToClientWithSeconds(item.deliveredAt) : null,
            createdAt: item.createdAt ? datetimeToClientWithSeconds(item.createdAt) : null,
            status: item.deliveredAt ? 'delivered' : 'pending'
          }));
          setMessageRows(formattedRows);
          setTotalShippingPages(shippingResponse.totalPages || 1);
        }
      }
    } catch (_) {
      // silencioso — não interrompe a UX
    } finally {
      refreshingRef.current = false;
    }
  };

  useEffect(() => {
    const companyId = user.companyId;

    const onCampaignEvent = (data) => {
      // "delete" não traz `record` (só `id`) — checar antes de acessar
      // data.record.id evita um TypeError que interrompia este listener
      // (e as atualizações em tempo real da tela) quando outra campanha
      // era excluída enquanto o relatório estava aberto.
      const eventId = data.action === "delete" ? data.id : data.record?.id;
      if (+eventId !== +campaignId) return;

      if (data.action === "delete") return;

      setCampaign(data.record);
      // Atualiza stats e tabela em tempo real a cada evento de envio
      refreshStats();
    };
    socket.on(`company-${companyId}-campaign`, onCampaignEvent);

    return () => {
      socket.off(`company-${companyId}-campaign`, onCampaignEvent);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaignId]);

  const findCampaign = async () => {
    try {
      setLoading(true);

      if (isTemplate) {
        // === RELATÓRIO DE META TEMPLATE ===
        const { data: stats } = await api.get(`/meta-templates/${campaignId}/stats`);
        setCampaign(stats.template || {});
        setDelivered(stats.sentMessages || 0);
        setValidContacts(stats.totalMessages || 0);
        setUniqueNumbers(stats.uniqueRecipients || 0);
        setFailedMessages(stats.failedMessages || 0);
        setTotalMessagesSent(stats.totalMessages || 0);

        setChartData({
          labels: ['Enviados', 'Aguardando', 'Falhas'],
          datasets: [{
            data: [stats.sentMessages, stats.pendingMessages, stats.failedMessages],
            backgroundColor: ['rgba(75,192,192,0.7)', 'rgba(255,206,86,0.7)', 'rgba(255,99,132,0.7)'],
            borderColor: ['rgba(75,192,192,1)', 'rgba(255,206,86,1)', 'rgba(255,99,132,1)'],
            borderWidth: 1,
          }],
        });

        // Itens do template como tabela
        try {
          const { data: itemsRes } = await api.get(`/meta-templates/${campaignId}/items`, {
            params: { pageNumber: 1, pageSize: rowsPerPage }
          });
          const formattedRows = (itemsRes.records || []).map(item => {
            const vars = item.variables || {};
            const varSummary = Object.entries(vars).map(([k, v]) => `${k}=${v}`).join(', ');
            const msgPreview = varSummary ? varSummary.substring(0, 50) : '(sem parâmetros)';
            const msgFull = varSummary || '(sem parâmetros)';
            return {
              id: item.id,
              jobId: item.id,
              number: item.contactName || '',
              message: msgPreview,
              fullMessage: msgFull,
              deliveredAt: item.status === 'sent' ? datetimeToClientWithSeconds(item.updatedAt) : null,
              createdAt: item.createdAt ? datetimeToClientWithSeconds(item.createdAt) : null,
              status: item.status === 'sent' ? 'delivered' : item.status === 'error' ? 'failed' : 'pending',
              errorMessage: item.errorMessage || null
            };
          });
          setMessageRows(formattedRows);
          setTotalShippingPages(Math.ceil((itemsRes.count || 0) / rowsPerPage) || 1);
        } catch (err) {
          setMessageRows([]);
        }

      } else {
        // === RELATÓRIO DE CAMPANHA NORMAL ===
        const { data: campaign } = await api.get(`/campaigns/${campaignId}`);
        setCampaign(campaign);

        try {
          const { data: stats } = await api.get(`/campaigns/${campaignId}/stats`);
          setDelivered(stats.deliveredMessages);
          setValidContacts(stats.totalMessages);
          setUniqueNumbers(stats.uniqueNumbers);
          setFailedMessages(stats.failedMessages);
          setTotalMessagesSent(stats.totalMessages);

          setChartData({
            labels: ['Entregues', 'Aguardando', 'Falhas'],
            datasets: [{
              data: [stats.deliveredMessages, stats.pendingMessages, stats.failedMessages],
              backgroundColor: ['rgba(75,192,192,0.7)', 'rgba(255,206,86,0.7)', 'rgba(255,99,132,0.7)'],
              borderColor: ['rgba(75,192,192,1)', 'rgba(255,206,86,1)', 'rgba(255,99,132,1)'],
              borderWidth: 1,
            }],
          });
        } catch (statsError) {
          console.error("Erro ao buscar estatísticas:", statsError);
          setDelivered(0); setValidContacts(0); setUniqueNumbers(0); setFailedMessages(0); setTotalMessagesSent(0);
        }

        try {
          const { data: shippingResponse } = await api.get(`/campaigns/${campaignId}/shipping?page=1&pageSize=${rowsPerPage}`);
          if (shippingResponse && shippingResponse.shipping) {
            const formattedRows = shippingResponse.shipping.map(item => ({
              id: item.id,
              jobId: item.jobId,
              number: item.number,
              message: item.message ? item.message.substring(0, 50) + (item.message.length > 50 ? '...' : '') : '',
              fullMessage: item.message || '',
              deliveredAt: item.deliveredAt ? datetimeToClientWithSeconds(item.deliveredAt) : null,
              createdAt: item.createdAt ? datetimeToClientWithSeconds(item.createdAt) : null,
              status: item.deliveredAt ? 'delivered' : 'pending'
            }));
            setMessageRows(formattedRows);
            setTotalShippingPages(shippingResponse.totalPages || 1);
            setShippingPage(shippingResponse.currentPage || 1);
          }
        } catch (shippingError) {
          console.error("Erro ao buscar dados de envio:", shippingError);
          setMessageRows([]);
        }
      }

    } catch (error) {
      console.error("Erro ao buscar campanha:", error);
      toast.error(i18n.t("campaignReport.fetchError"));
    } finally {
      setLoading(false);
    }
  };

  const formatStatus = (val) => {
    switch (val) {
      case "INATIVA":
        return i18n.t("campaignReport.inactive");
      case "PROGRAMADA":
        return i18n.t("campaignReport.scheduled");
      case "EM_ANDAMENTO":
        return i18n.t("campaignReport.process");
      case "CANCELADA":
        return i18n.t("campaignReport.cancelled");
      case "FINALIZADA":
        return i18n.t("campaignReport.finished");
      default:
        return val;
    }
  };
  
  // Manipuladores para a paginação da tabela
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    // Carregar dados com novo tamanho de página
    loadMoreShipping(1, parseInt(event.target.value, 10));
  };
  
  // Função para carregar mais dados de shipping
  const loadMoreShipping = async (newPage = 1, pageSize = 50) => {
    try {
      setLoading(true);

      if (isTemplate) {
        const { data: itemsRes } = await api.get(`/meta-templates/${campaignId}/items`, {
          params: { pageNumber: newPage, pageSize }
        });
        const formattedRows = (itemsRes.records || []).map(item => {
          const vars = item.variables || {};
          const varSummary = Object.entries(vars).map(([k, v]) => `${k}=${v}`).join(', ');
          const msgPreview = varSummary ? varSummary.substring(0, 50) : '(sem parâmetros)';
          return {
            id: item.id,
            jobId: item.id,
            number: item.contactName || '',
            message: msgPreview,
            fullMessage: varSummary || '(sem parâmetros)',
            deliveredAt: item.status === 'sent' ? datetimeToClientWithSeconds(item.updatedAt) : null,
            createdAt: item.createdAt ? datetimeToClientWithSeconds(item.createdAt) : null,
            status: item.status === 'sent' ? 'delivered' : item.status === 'error' ? 'failed' : 'pending',
            errorMessage: item.errorMessage || null
          };
        });
        setMessageRows(formattedRows);
        setTotalShippingPages(Math.ceil((itemsRes.count || 0) / pageSize) || 1);
        return;
      }

      const url = `/campaigns/${campaignId}/shipping?page=${newPage}&pageSize=${pageSize}`;
      const { data: shippingResponse } = await api.get(url);

      if (shippingResponse && shippingResponse.shipping) {
        const shippingData = shippingResponse.shipping;

        // Processar dados para a tabela
        const formattedRows = shippingData.map(item => ({
          id: item.id,
          jobId: item.jobId,
          number: item.number,
          message: item.message ? item.message.substring(0, 50) + (item.message.length > 50 ? '...' : '') : '',
          fullMessage: item.message || '',
          deliveredAt: item.deliveredAt ? datetimeToClientWithSeconds(item.deliveredAt) : null,
          createdAt: item.createdAt ? datetimeToClientWithSeconds(item.createdAt) : null,
          status: item.deliveredAt ? 'delivered' : 'pending'
        }));

        setMessageRows(formattedRows);
        setTotalShippingPages(shippingResponse.totalPages || 1);
        setShippingPage(shippingResponse.currentPage || 1);

      } else {
        setMessageRows([]);
      }
    } catch (error) {
      console.error("Erro ao carregar mais dados de envio:", error);
      toast.error("Erro ao carregar dados de envio");
      setMessageRows([]);
    } finally {
      setLoading(false);
    }
  };
  
  // Função para formatar o número de telefone
  const formatPhoneNumber = (number) => {
    if (!number) return '';
    
    // Verifica se é um ID de grupo (normalmente começa com números grandes)
    if (number.length > 15) {
      return `Grupo (${number.substring(0, 6)}...)`;
    }
    
    // Formata número normal
    if (number.length === 12 && number.startsWith('55')) {
      const ddd = number.substring(2, 4);
      const firstPart = number.substring(4, 9);
      const lastPart = number.substring(9);
      return `+55 (${ddd}) ${firstPart}-${lastPart}`;
    }
    
    return number;
  };
  
  // Função para obter o status do envio
  const getMessageStatusChip = (status) => {
    switch (status) {
      case 'delivered':
        return (
          <Chip 
            label="Entregue" 
            size="small" 
            icon={<DoneAllIcon fontSize="small" />} 
            className={`${classes.statusChip} ${classes.deliveredChip}`} 
          />
        );
      case 'sent':
        return (
          <Chip
            label="Enviado"
            size="small"
            icon={<DoneIcon fontSize="small" />}
            className={`${classes.statusChip} ${classes.deliveredChip}`}
          />
        );
      case 'error':
        return (
          <Chip
            label="Erro"
            size="small"
            icon={<ErrorIcon fontSize="small" />}
            className={`${classes.statusChip} ${classes.failedChip}`}
          />
        );
      case 'pending':
        return (
          <Chip
            label="Pendente"
            size="small"
            icon={<ScheduleIcon fontSize="small" />}
            className={`${classes.statusChip} ${classes.pendingChip}`}
          />
        );
      case 'failed':
        return (
          <Chip 
            label="Falha" 
            size="small" 
            icon={<ErrorIcon fontSize="small" />} 
            className={`${classes.statusChip} ${classes.failedChip}`} 
          />
        );
      default:
        return (
          <Chip 
            label="Desconhecido" 
            size="small" 
            variant="outlined" 
          />
        );
    }
  };

  // Função para exportar dados para Excel
  const exportToExcel = async () => {
    try {
      toast.info("Gerando relatório Excel, aguarde...");

      let excelData = [];
      let fileName = '';

      if (isTemplate) {
        // Buscar todos os itens do template
        let allItems = [];
        let currentPage = 1;
        let hasMore = true;
        const pageSize = 5000;

        while (hasMore) {
          const { data: itemsRes } = await api.get(`/meta-templates/${campaignId}/items`, {
            params: { pageNumber: currentPage, pageSize }
          });
          allItems = [...allItems, ...(itemsRes.records || [])];
          hasMore = itemsRes.hasMore;
          currentPage++;
        }

        if (allItems.length === 0) {
          toast.error("Nenhum dado encontrado para exportar");
          return;
        }

        // Coletar todas as chaves de variáveis
        const varKeys = Array.from(new Set(allItems.flatMap(item => Object.keys(item.variables || {}))));

        excelData = [
          ["Relatório de Template Meta", "", "", "", ""],
          [`Template: ${campaign.name}`, "", "", "", ""],
          [`Data de Geração: ${new Date().toLocaleString('pt-BR')}`, "", "", "", ""],
          [""],
          ["ID", "Contato", "Status", "Motivo da Falha", ...varKeys],
          ...allItems.map(item => [
            item.id,
            item.contactName || '',
            item.status || '',
            item.status === 'error' ? (item.errorMessage || '') : '',
            ...varKeys.map(k => (item.variables || {})[k] || '')
          ])
        ];

        fileName = `relatorio_template_${(campaign.name || 'meta').replace(/[^a-zA-Z0-9]/g, '_')}_${new Date().toISOString().split('T')[0]}.xlsx`;

      } else {
        // Buscar todos os dados de shipping em lotes
        let allShippingData = [];
        let currentPage = 1;
        let hasMoreData = true;
        const pageSize = 1000;

        while (hasMoreData) {
          const { data: shippingResponse } = await api.get(`/campaigns/${campaignId}/shipping?page=${currentPage}&pageSize=${pageSize}`);

          if (!shippingResponse || !shippingResponse.shipping) break;

          allShippingData = [...allShippingData, ...shippingResponse.shipping];
          hasMoreData = currentPage < shippingResponse.totalPages;
          currentPage++;
        }

        if (allShippingData.length === 0) {
          toast.error("Nenhum dado encontrado para exportar");
          return;
        }

        excelData = [
          ["Relatório de Campanha", "", "", "", "", ""],
          [`Campanha: ${campaign.name}`, "", "", "", "", ""],
          [`Data de Geração: ${new Date().toLocaleString('pt-BR')}`, "", "", "", "", ""],
          ["", "", "", "", "", ""],
          ["ID", "Destinatário", "Mensagem", "Enviado em", "Entregue em", "Status"],
          ...allShippingData.map(item => [
            item.jobId || '',
            item.number || '',
            item.message || '',
            item.createdAt ? new Date(item.createdAt).toLocaleString('pt-BR') : '',
            item.deliveredAt ? new Date(item.deliveredAt).toLocaleString('pt-BR') : '',
            item.deliveredAt ? 'Entregue' : 'Pendente'
          ])
        ];

        fileName = `relatorio_campanha_${(campaign.name || 'campanha').replace(/[^a-zA-Z0-9]/g, '_')}_${new Date().toISOString().split('T')[0]}.xlsx`;
      }

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.aoa_to_sheet(excelData);
      XLSX.utils.book_append_sheet(wb, ws, "Relatório");
      XLSX.writeFile(wb, fileName);

      toast.success(`Relatório Excel gerado com sucesso!`);

    } catch (error) {
      console.error("Erro ao exportar para Excel:", error);
      toast.error("Erro ao gerar relatório Excel");
    }
  };

  return (
    <MainContainer>
      <MainHeader>
        <Grid style={{ width: "99.6%" }} container>
          <Grid xs={12} item style={{ display: "flex", alignItems: "center" }}>
            <Button
              variant="outlined"
              color="primary"
              style={{ marginRight: 10 }}
              onClick={() => history.push('/campaigns')}
              startIcon={<ArrowBackIcon />}
            >
              {i18n.t("campaignReport.backButton")}
            </Button>
            <Title>{i18n.t("campaignReport.title")} {campaign.name || i18n.t("campaignReport.campaign")}</Title>
          </Grid>
        </Grid>
      </MainHeader>
      
      {/* Card com resumo e status */}
      <Paper className={classes.mainPaper} variant="outlined">
        <Box mb={2}>
          <Typography variant="h5" component="h2" gutterBottom>
            {campaign.name || i18n.t("campaignReport.campaign")}
          </Typography>
          <Chip 
            label={formatStatus(campaign.status)} 
            color={campaign.status === "FINALIZADA" ? "primary" : "default"}
            style={{ fontWeight: 'bold', marginRight: 8 }}
          />
        </Box>
        
        <Grid container spacing={3} className={classes.summaryCards}>
          {/* Card de Status */}
          <Grid item xs={12} md={6} lg={3}>
            <Card className={classes.summaryCard} variant="outlined">
              <CardContent>
                <Typography variant="h6" color="textSecondary" gutterBottom>
                  Status de Entrega
                </Typography>
                <Box className={classes.pieChartContainer}>
                  <Doughnut data={chartData} options={chartOptions} />
                </Box>
              </CardContent>
            </Card>
          </Grid>
          
          {/* Cards com estatísticas principais */}
          <Grid item xs={12} md={6} lg={3}>
            <Card className={classes.summaryCard} variant="outlined">
              <CardContent>
                <SendIcon className={classes.cardIcon} />
                <Typography variant="h4" component="div">
                  {delivered}
                </Typography>
                <Typography color="textSecondary">
                  Mensagens Enviadas
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          
          <Grid item xs={12} md={6} lg={3}>
            <Card className={classes.summaryCard} variant="outlined">
              <CardContent>
                <PhoneIcon className={classes.cardIcon} />
                <Typography variant="h4" component="div">
                  {uniqueNumbers}
                </Typography>
                <Typography color="textSecondary">
                  Destinatários Únicos
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          
          <Grid item xs={12} md={6} lg={3}>
            <Card className={classes.summaryCard} variant="outlined">
              <CardContent>
                <CheckCircleIcon className={classes.cardIcon} />
                <Typography variant="h4" component="div">
                  {delivered}
                </Typography>
                <Typography color="textSecondary">
                  Mensagens Entregues
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        
        {/* Barra de progresso */}
        <Box className={classes.progressContainer}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs>
              <Typography variant="body2" color="textSecondary">{i18n.t("campaignReport.deliver")}</Typography>
            </Grid>
            <Grid item>
              <Typography variant="body2" color="textPrimary">
                {delivered} de {totalMessagesSent}
              </Typography>
            </Grid>
          </Grid>
          <LinearProgress
            variant="determinate"
            style={{ height: 10, borderRadius: 5, margin: "8px 0" }}
            value={(delivered / (totalMessagesSent || 1)) * 100}
          />
        </Box>
        
        {/* Informações adicionais da campanha */}
        <Grid container spacing={3}>
          {campaign.whatsappId && (
            <Grid item xs={12} md={4}>
              <Card variant="outlined" className={classes.detailsCard}>
                <CardHeader
                  avatar={
                    <Avatar className={classes.avatar}>
                      <WhatsAppIcon />
                    </Avatar>
                  }
                  title="Conexão WhatsApp"
                  subheader={campaign.whatsapp?.name || "Não especificado"}
                />
              </Card>
            </Grid>
          )}
          
          {campaign.tagListId && (
            <Grid item xs={12} md={4}>
              <Card variant="outlined" className={classes.detailsCard}>
                <CardHeader
                  avatar={
                    <Avatar className={classes.avatar}>
                      <ListAltIcon />
                    </Avatar>
                  }
                  title="Tag Utilizada"
                  subheader={`ID: ${campaign.tagListId}`}
                />
              </Card>
            </Grid>
          )}
          
          {campaign.contactListId && (
            <Grid item xs={12} md={4}>
              <Card variant="outlined" className={classes.detailsCard}>
                <CardHeader
                  avatar={
                    <Avatar className={classes.avatar}>
                      <ListAltIcon />
                    </Avatar>
                  }
                  title={i18n.t("campaignReport.contactLists")}
                  subheader={campaign.contactList?.name || "Não especificado"}
                />
              </Card>
            </Grid>
          )}
          
          <Grid item xs={12} md={4}>
            <Card variant="outlined" className={classes.detailsCard}>
              <CardHeader
                avatar={
                  <Avatar className={classes.avatar}>
                    <ScheduleIcon />
                  </Avatar>
                }
                title={i18n.t("campaignReport.schedule")}
                subheader={datetimeToClient(campaign.scheduledAt) || "Não agendado"}
              />
            </Card>
          </Grid>
          
          <Grid item xs={12} md={4}>
            <Card variant="outlined" className={classes.detailsCard}>
              <CardHeader
                avatar={
                  <Avatar className={classes.avatar}>
                    <EventAvailableIcon />
                  </Avatar>
                }
                title={i18n.t("campaignReport.conclusion")}
                subheader={datetimeToClient(campaign.completedAt) || "Não concluído"}
              />
            </Card>
          </Grid>
        </Grid>
        
        {/* Seção de detalhes de mensagens */}
        <Box mt={4}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="h6" className={classes.sectionTitle}>
              <MessageIcon style={{ verticalAlign: 'middle', marginRight: 8 }} />
              Detalhes das Mensagens
            </Typography>
            <Button
              variant="contained"
              color="primary"
              startIcon={<GetAppIcon />}
              onClick={exportToExcel}
              style={{
                borderRadius: 20,
                textTransform: 'none',
                fontWeight: 'bold',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                background: 'linear-gradient(45deg, #4CAF50 30%, #45a049 90%)',
                '&:hover': {
                  background: 'linear-gradient(45deg, #45a049 30%, #4CAF50 90%)',
                  boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
                }
              }}
            >
              Exportar Excel
            </Button>
          </Box>
          <Divider />
          
          <TableContainer className={classes.tableContainer}>
            <Table aria-label="tabela de mensagens">
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Destinatário</TableCell>
                  <TableCell>Mensagem</TableCell>
                  <TableCell>Enviado em</TableCell>
                  <TableCell>Entregue em</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Motivo da Falha</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {messageRows.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell>{row.jobId}</TableCell>
                    <TableCell>
                      <Tooltip title={row.number}>
                        <span>{formatPhoneNumber(row.number)}</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell>
                      <Tooltip title={row.fullMessage}>
                        <span>{row.message}</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell>{row.createdAt}</TableCell>
                    <TableCell>{row.deliveredAt || '-'}</TableCell>
                    <TableCell>{getMessageStatusChip(row.status)}</TableCell>
                    <TableCell>
                      {row.status === 'failed' && row.errorMessage ? (
                        <Tooltip title={row.errorMessage}>
                          <span style={{ color: '#f44336' }}>
                            {row.errorMessage.length > 40 ? `${row.errorMessage.substring(0, 40)}...` : row.errorMessage}
                          </span>
                        </Tooltip>
                      ) : '-'}
                    </TableCell>
                  </TableRow>
                ))}
                {messageRows.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      {loading ? "Carregando..." : "Nenhuma mensagem encontrada"}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[10, 25, 50, 100]}
              component="div"
              count={totalMessagesSent}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={(event, newPage) => {
                setPage(newPage);
                // Calcular qual página de dados carregar do servidor
                const serverPage = newPage + 1;
                loadMoreShipping(serverPage, rowsPerPage);
              }}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage="Linhas por página:"
              labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
            />
          </TableContainer>
        </Box>
      </Paper>
    </MainContainer>
  );
};

export default CampaignReport;
